// Modified by iGotSolutions for Maximus Bot
import type { ThreadMessage } from "@rakazo/contracts";
import { isApprovalAskBlock } from "@rakazo/core";
import { AskCard } from "./AskCard";

/** The pending approval, pinned above the composer so it stays visible. */
export function PendingApprovalBar({
  message,
  onAnswer,
}: {
  message: ThreadMessage;
  onAnswer: (
    message: ThreadMessage,
    text: string,
    username?: string,
    dismiss?: boolean,
  ) => Promise<void>;
}) {
  const block = message.blocks.find(
    (candidate) =>
      candidate.kind === "ask" && isApprovalAskBlock(candidate) && candidate.status !== "answered",
  );
  if (block?.kind !== "ask") return null;
  return (
    <div data-testid="pending-approval-bar" className="px-6 pb-2">
      <AskCard
        block={block}
        canAnswer
        canDismiss={false}
        onAnswer={(text, username) => onAnswer(message, text, username)}
        onDismiss={async () => undefined}
      />
    </div>
  );
}
